/** The custody ID used to identify vault selection in wallet switchers */
export const VAULT_CUSTODY_ID = 'vault' as const;

// If modifying this type, also modify the type in packages/chain-config/src/useActiveFrontendChainKeys.ts
export const CUSTODIES = [
  'wallet', // Note: since multi-wallet support, this is more of a "category" than a precise custody
  VAULT_CUSTODY_ID,
  'external-signer', // External signing devices (hardware wallets, etc.) requiring client-side signing
  'multi-sig', // Multi-signature wallets (e.g. Gnosis Safe) requiring multiple signers
] as const;
export type Custody = (typeof CUSTODIES)[number];

/**
 * Category of address known to Infinex.
 * Used mainly in send/move to prevent mistakes.
 * This may be extended in the future e.g. `... | 'addressBook' | 'trustedDappContract'`
 */
export type KnownAddressCategory =
  | 'recovery' // funds recovery
  | Custody;
